import { toast } from 'sonner'
import { ApiError } from '@/lib/api'
import { INTERVALS } from '@/lib/constants'

/** Longitud visible del código de referencia (el requestId completo es un UUID largo). */
const REFERENCE_CODE_LENGTH = 8

/** Código corto de referencia para que soporte técnico encuentre la solicitud en los registros. */
export function referenceCode(error: unknown): string | null {
  if (!(error instanceof ApiError) || !error.requestId) return null
  return error.requestId.slice(0, REFERENCE_CODE_LENGTH).toUpperCase()
}

/** Mensaje legible para cualquier error (los del API ya vienen en español). */
export function errorMessage(error: unknown, fallback = 'No se pudo completar la operación.'): string {
  if (error instanceof ApiError) return error.message
  if (error instanceof Error && error.message) return error.message
  return fallback
}

/**
 * Muestra un aviso de error con el mensaje del API y, si existe, el código
 * de referencia (requestId) para reportarlo a soporte.
 */
export function notifyError(error: unknown, title?: string): void {
  const code = referenceCode(error)
  const message = errorMessage(error)
  toast.error(title ?? message, {
    description: [title ? message : null, code ? `Código de referencia: ${code}` : null].filter(Boolean).join(' · ') || undefined,
    duration: INTERVALS.errorToastMs,
  })
}

/** Muestra un aviso de éxito breve. */
export function notifySuccess(message: string, description?: string): void {
  toast.success(message, description ? { description } : undefined)
}
